import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { API_URL, getCachedSessionId } from '../../services/common';
import { useNotification } from '../../providers/notificationsProvider';

const transferDomain = async ({ domain, projectId }) => {
  const response = await axios.post(
    `${API_URL}/v1/project/${projectId}/provider/domain/transfer`,
    domain,
    {
      headers: { 'x-session-id': getCachedSessionId() }
    }
  );

  return response.data;
};

export const useTransferDomain = () => {
  const queryClient = useQueryClient();
  const { notify } = useNotification();

  return useMutation(transferDomain, {
    onError: (error) => {
      notify({ message: error.message, severity: 'error' });
    },
    onSuccess: () => {
      notify({ message: 'Domain was transferred successfully', severity: 'success' });
      queryClient.invalidateQueries(['domains']);
    }
  });
};
